module.exports = __webpack_public_path__ + "static/media/iconfont.94f41d87.svg";